var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useLayoutEffect } from 'react';
import { useOnceAsync } from '../use-once';
import { useSingleCollectionValue } from './use-shared-collection';
export function useResolvedCollectionValue(key, valueKey) {
    var _this = this;
    var _a = useSingleCollectionValue(key, valueKey), value = _a[0], setValue = _a[1];
    useOnceAsync(function () { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
        return [2 /*return*/, (_a = key.resolver) === null || _a === void 0 ? void 0 : _a.initialize()];
    }); }); });
    useLayoutEffect(function () { return requestValue(); }, [valueKey, value]);
    useEffect(function () {
        var _a;
        (_a = key.resolver) === null || _a === void 0 ? void 0 : _a.resolveRequests();
    });
    function requestValue() {
        var _a;
        if (valueKey && value === undefined) {
            (_a = key.resolver) === null || _a === void 0 ? void 0 : _a.requestValue(valueKey);
        }
    }
    return [value, setValue];
}
export function useCollectionValuesResolution(key, keys, values) {
    var _this = this;
    if (!key.resolver)
        return;
    useOnceAsync(function () { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
        return [2 /*return*/, (_a = key.resolver) === null || _a === void 0 ? void 0 : _a.initialize()];
    }); }); });
    useLayoutEffect(function () { return requestValues(); }, [keys, values]);
    useEffect(function () {
        var _a;
        (_a = key.resolver) === null || _a === void 0 ? void 0 : _a.resolveRequests();
    });
    function requestValues() {
        if (!keys)
            return;
        keys.filter(function (valueKey) { return values[valueKey] === undefined; }).forEach(function (valueKey) { var _a; return (_a = key.resolver) === null || _a === void 0 ? void 0 : _a.requestValue(valueKey); });
    }
}
var SharedCollectionResolverState;
(function (SharedCollectionResolverState) {
    SharedCollectionResolverState[SharedCollectionResolverState["INITIALIZING"] = 0] = "INITIALIZING";
    SharedCollectionResolverState[SharedCollectionResolverState["INITIALIZED"] = 1] = "INITIALIZED";
    SharedCollectionResolverState[SharedCollectionResolverState["NOT_INITIALIZED"] = 2] = "NOT_INITIALIZED";
})(SharedCollectionResolverState || (SharedCollectionResolverState = {}));
var NOT_INITIALIZED = SharedCollectionResolverState.NOT_INITIALIZED, INITIALIZED = SharedCollectionResolverState.INITIALIZED, INITIALIZING = SharedCollectionResolverState.INITIALIZING;
var SharedCollectionResolver = /** @class */ (function () {
    function SharedCollectionResolver(name, collection, resolver) {
        var _this = this;
        this.resolveSinglesBatch = function (requests, modify) { return __awaiter(_this, void 0, void 0, function () {
            var promises;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promises = requests.map(function (request) { return __awaiter(_this, void 0, void 0, function () {
                            var value, error_1;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _c.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, ((_b = (_a = this.resolver).resolve) === null || _b === void 0 ? void 0 : _b.call(_a, request))];
                                    case 1:
                                        value = _c.sent();
                                        if (value) {
                                            modify.setValue(request, value);
                                        }
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_1 = _c.sent();
                                        console.error("Error resolving ".concat(this.name, " value for ").concat(request), { error: error_1 });
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.name = name;
        this.collection = collection;
        this.resolver = resolver;
        this.state = resolver.initialize ? NOT_INITIALIZED : INITIALIZED;
        this.pending = [];
        this.resolving = [];
    }
    SharedCollectionResolver.prototype.requestValue = function (valueKey) {
        if (this.collection.hasKey(valueKey))
            return;
        if (this.pending.indexOf(valueKey) !== -1)
            return;
        this.pending.push(valueKey);
    };
    SharedCollectionResolver.prototype.initialize = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.state !== NOT_INITIALIZED)
                            return [2 /*return*/];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        this.state = INITIALIZING;
                        return [4 /*yield*/, ((_b = (_a = this.resolver).initialize) === null || _b === void 0 ? void 0 : _b.call(_a, this.collection))];
                    case 2:
                        _c.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _c.sent();
                        console.error("Error initializing ".concat(this.name), { error: error_2 });
                        return [3 /*break*/, 5];
                    case 4:
                        this.pending = this.pending.filter(function (request) { return !_this.collection.hasKey(request); });
                        this.state = INITIALIZED;
                        this.resolveRequests();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SharedCollectionResolver.prototype.resolveRequests = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requests, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.pending.length === 0)
                            return [2 /*return*/];
                        if (this.state === INITIALIZING)
                            return [2 /*return*/];
                        requests = this.popPendingRequests();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.resolving = this.resolving.concat(requests);
                        return [4 /*yield*/, this.resolveBatch(requests)];
                    case 2:
                        _a.sent();
                        this.resolveUnresolvedRequests(requests);
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _a.sent();
                        console.error("Error resolving ".concat(this.name, " batch"), { error: error_3 });
                        return [3 /*break*/, 5];
                    case 4:
                        this.removeFromResolving(requests);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SharedCollectionResolver.prototype.isResolving = function (key) {
        if (this.state === INITIALIZING)
            return true;
        if (this.pending.includes(key))
            return true;
        if (this.resolving.includes(key))
            return true;
        return false;
    };
    SharedCollectionResolver.prototype.valuesChanged = function (update) {
        if (this.resolver.valuesUpdated) {
            this.resolver.valuesUpdated(update);
        }
    };
    SharedCollectionResolver.prototype.valuesRemoved = function (keys) {
        if (this.resolver.valuesRemoved) {
            this.resolver.valuesRemoved(keys);
        }
    };
    SharedCollectionResolver.prototype.resolveBatch = function (requests) {
        if (this.resolver.resolveBatch) {
            // ugly type hack
            return this.resolver.resolveBatch(requests, this.collection);
        }
        else {
            return this.resolveSinglesBatch(requests, this.collection);
        }
    };
    SharedCollectionResolver.prototype.resolveUnresolvedRequests = function (requests) {
        var update = {};
        var shouldUpdate = false;
        for (var _i = 0, requests_1 = requests; _i < requests_1.length; _i++) {
            var request = requests_1[_i];
            if (!this.collection.hasKey(request)) {
                update[request] = null;
                shouldUpdate = true;
            }
        }
        if (shouldUpdate === true)
            this.collection.update(update);
    };
    SharedCollectionResolver.prototype.popPendingRequests = function () {
        var popped = __spreadArray([], this.pending, true);
        this.pending = [];
        return popped;
    };
    SharedCollectionResolver.prototype.removeFromResolving = function (requests) {
        this.resolving = this.resolving.filter(function (fkey) { return !requests.includes(fkey); });
    };
    return SharedCollectionResolver;
}());
export { SharedCollectionResolver };
//# sourceMappingURL=shared-value-resolving.js.map